export const getTransitionByIdSelector = (state, { id }) =>
  getTransitionById(state.transitionsReducer, id);

export const getTransitionById = (transitions, id) =>
  transitions.find(transition => transition.id === id);
